(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function closest(el, sel) {
      return el && el.closest ? el.closest(sel) : null;
    }

    function openMob() {
      var m = document.getElementById('mobnav');
      if (m) m.classList.add('open');
      document.body.style.overflow = 'hidden';
    }

    function closeMob() {
      var m = document.getElementById('mobnav');
      if (m) m.classList.remove('open');
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function (e) {
      // Close language dropdown when clicking outside it.
      var openLang = document.querySelector('.lang.open');
      if (openLang && !closest(e.target, '.lang')) {
        openLang.classList.remove('open');
        var t = openLang.querySelector('[data-lang-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      }

      var toggle = closest(e.target, '[data-lang-toggle]');
      if (toggle) {
        var lang = closest(toggle, '.lang');
        var isOpen = lang.classList.toggle('open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        return;
      }

      if (closest(e.target, '[data-open-mob]')) {
        e.preventDefault();
        openMob();
        return;
      }
      if (closest(e.target, '[data-close-mob]')) {
        closeMob();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMob();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roast-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var QUIZ = [];

    var quizContent = document.querySelector('[data-quiz-content]');
    var quizCopy = { step: 'Step', intro: '', tagline: '', back: '← Back' };
    var quizCopyEl = document.querySelector('[data-quiz-copy]');
    try {
      if (quizContent) QUIZ = JSON.parse(quizContent.textContent);
    } catch (e) {}
    try {
      if (quizCopyEl) quizCopy = JSON.parse(quizCopyEl.textContent);
    } catch (e) {}

    function initQuiz(root) {
      if (root.dataset.quizReady) return;
      root.dataset.quizReady = '1';
      var steps = root.querySelector('[data-quiz-steps]');
      var results = root.querySelectorAll('[data-result]');
      var qStep = 0;
      var scores = {};
      var selectedMethods = [];
      var answers = [];

      function hideResults() {
        for (var i = 0; i < results.length; i++) results[i].hidden = true;
      }

      function rebuildScores() {
        scores = {};
        selectedMethods = [];
        for (var i = 0; i < answers.length; i++) {
          var answer = answers[i];
          for (var key in answer.w) scores[key] = (scores[key] || 0) + answer.w[key];
          if (answer.methods) selectedMethods = answer.methods;
        }
      }

      function renderStep() {
        if (qStep >= QUIZ.length) {
          finish();
          return;
        }
        var s = QUIZ[qStep];
        var progress = '';
        for (var i = 0; i < QUIZ.length; i++) {
          progress += '<i class="' + (i <= qStep ? 'on' : '') + '"></i>';
        }
        var opts = '';
        for (var j = 0; j < s.opts.length; j++) {
          var o = s.opts[j];
          opts +=
            '<button class="quiz__opt" data-pick="' +
            j +
            '"><span class="ord">0' +
            (j + 1) +
            '</span><span class="lbl">' +
            o.lbl +
            '<small>' +
            o.sub +
            '</small></span></button>';
        }
        steps.innerHTML =
          '<div class="quiz__inner">' +
          '<div class="quiz__side ticked" data-auto-ticks style="--tick-inset:20px;--tick-color:rgba(255,255,255,0.25);">' +
          '<div><div class="step-no">' +
          quizCopy.step +
          ' ' +
          (qStep + 1) +
          ' / ' +
          QUIZ.length +
          ' · ' +
          s.step +
          '</div><div class="quiz__progress">' +
          progress +
          '</div></div>' +
          '<div><div class="wordmark" style="font-size:30px;color:var(--paper-on-ink);">OBRIY</div>' +
          '<div class="horizon" data-color="var(--accent)" data-size="18" data-width="130" style="margin-top:16px;color:#fff;justify-content:flex-start;"></div>' +
          '<p class="quiz__intro-copy">' +
          quizCopy.intro +
          '</p></div>' +
          '<div class="mono" style="font-size:9px;color:rgba(240,236,225,0.5);">' +
          quizCopy.tagline +
          '</div>' +
          '</div>' +
          '<div class="quiz__main"><div class="quiz__q">' +
          s.q +
          '</div><div class="quiz__opts">' +
          opts +
          '</div>' +
          (qStep > 0
            ? '<button class="quiz__back" data-qback>' + quizCopy.back + '</button>'
            : '') +
          '</div></div>';
        steps.hidden = false;
        hideResults();
        root.classList.remove('is-transitioning');
        void root.offsetWidth;
        root.classList.add('is-transitioning');
        if (window.obriyHydrate) window.obriyHydrate(steps);
      }

      function finish() {
        var best = null;
        var bestScore = -1;
        var hasMethodMatch = false;

        for (var i = 0; i < results.length; i++) {
          var availableMethods = (results[i].getAttribute('data-methods') || '').split(/\s+/);
          for (var j = 0; j < selectedMethods.length; j++) {
            if (availableMethods.indexOf(selectedMethods[j]) >= 0) hasMethodMatch = true;
          }
        }

        for (var i = 0; i < results.length; i++) {
          var profile = results[i].getAttribute('data-profile');
          var candidateMethods = (results[i].getAttribute('data-methods') || '').split(/\s+/);
          var sc = scores[profile] || 0;
          var matchesMethod = false;
          for (var j = 0; j < selectedMethods.length; j++) {
            if (candidateMethods.indexOf(selectedMethods[j]) >= 0) {
              matchesMethod = true;
              sc += 8;
            }
          }
          if (hasMethodMatch && !matchesMethod) continue;
          if (sc > bestScore) {
            bestScore = sc;
            best = results[i];
          }
        }
        steps.hidden = true;
        if (best) {
          best.hidden = false;
          best.classList.remove('is-revealed');
          void best.offsetWidth;
          best.classList.add('is-revealed');
          if (window.obriyHydrate) window.obriyHydrate(best);
        }
      }

      function pick(i) {
        answers[qStep] = QUIZ[qStep].opts[i];
        rebuildScores();
        qStep++;
        renderStep();
      }

      root.addEventListener('click', function (e) {
        var p = e.target.closest('[data-pick]');
        if (p && steps.contains(p)) {
          pick(parseInt(p.getAttribute('data-pick'), 10));
          return;
        }
        if (e.target.closest('[data-qback]')) {
          qStep = Math.max(0, qStep - 1);
          answers = answers.slice(0, qStep);
          rebuildScores();
          renderStep();
          return;
        }
        if (e.target.closest('[data-qrestart]')) {
          qStep = 0;
          answers = [];
          rebuildScores();
          renderStep();
          return;
        }
      });

      renderStep();
    }

    function initAll(scope) {
      var nodes = (scope || document).querySelectorAll('[data-quiz]');
      for (var i = 0; i < nodes.length; i++) initQuiz(nodes[i]);
    }

    if (document.readyState !== 'loading') initAll();
    else
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
